export default "__VITE_ASSET__cd218d25__"